var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product)?_c('AddOrEdit',{ref:"form",attrs:{"edit":true,"editData":_vm.product,"type":_vm.product.type},on:{"updated":function($event){return _vm.fetchProduct(true)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }